/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    SupplierLocationMappingFormData,
    SupplierLocationMappingFormDataFromJSON,
    SupplierLocationMappingFormDataToJSON,
    SupplierLocationMappingFormDataConfiguration,
    SupplierLocationMappingFormDataConfigurationFromJSON,
    SupplierLocationMappingFormDataConfigurationToJSON,
    SupplierLocationMappingValidationData,
    SupplierLocationMappingValidationDataFromJSON,
    SupplierLocationMappingValidationDataToJSON,
} from '../models';

export interface ApiSupplierLocationMappingFormCreatePostRequest {
    supplierLocationMappingFormData?: SupplierLocationMappingFormData;
}

export interface ApiSupplierLocationMappingFormDataGetRequest {
    id?: string;
}

export interface ApiSupplierLocationMappingFormIdDeleteRequest {
    id: string;
}

export interface ApiSupplierLocationMappingFormUpdatePostRequest {
    supplierLocationMappingFormData?: SupplierLocationMappingFormData;
}

export interface ApiSupplierLocationMappingFormValidatePostRequest {
    supplierLocationMappingFormData?: SupplierLocationMappingFormData;
}

/**
 * no description
 */
export class SupplierLocationMappingFormApi extends runtime.BaseAPI {

    /**
     */
    async apiSupplierLocationMappingFormConfigurationGetRaw(): Promise<runtime.ApiResponse<SupplierLocationMappingFormDataConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SupplierLocationMappingForm/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupplierLocationMappingFormDataConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiSupplierLocationMappingFormConfigurationGet(): Promise<SupplierLocationMappingFormDataConfiguration> {
        const response = await this.apiSupplierLocationMappingFormConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiSupplierLocationMappingFormCreatePostRaw(requestParameters: ApiSupplierLocationMappingFormCreatePostRequest): Promise<runtime.ApiResponse<string>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SupplierLocationMappingForm/Create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupplierLocationMappingFormDataToJSON(requestParameters.supplierLocationMappingFormData),
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async apiSupplierLocationMappingFormCreatePost(requestParameters: ApiSupplierLocationMappingFormCreatePostRequest): Promise<string> {
        const response = await this.apiSupplierLocationMappingFormCreatePostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiSupplierLocationMappingFormDataGetRaw(requestParameters: ApiSupplierLocationMappingFormDataGetRequest): Promise<runtime.ApiResponse<SupplierLocationMappingFormData>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SupplierLocationMappingForm/Data`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupplierLocationMappingFormDataFromJSON(jsonValue));
    }

    /**
     */
    async apiSupplierLocationMappingFormDataGet(requestParameters: ApiSupplierLocationMappingFormDataGetRequest): Promise<SupplierLocationMappingFormData> {
        const response = await this.apiSupplierLocationMappingFormDataGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiSupplierLocationMappingFormIdDeleteRaw(requestParameters: ApiSupplierLocationMappingFormIdDeleteRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiSupplierLocationMappingFormIdDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SupplierLocationMappingForm/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiSupplierLocationMappingFormIdDelete(requestParameters: ApiSupplierLocationMappingFormIdDeleteRequest): Promise<void> {
        await this.apiSupplierLocationMappingFormIdDeleteRaw(requestParameters);
    }

    /**
     */
    async apiSupplierLocationMappingFormUpdatePostRaw(requestParameters: ApiSupplierLocationMappingFormUpdatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SupplierLocationMappingForm/Update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupplierLocationMappingFormDataToJSON(requestParameters.supplierLocationMappingFormData),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiSupplierLocationMappingFormUpdatePost(requestParameters: ApiSupplierLocationMappingFormUpdatePostRequest): Promise<void> {
        await this.apiSupplierLocationMappingFormUpdatePostRaw(requestParameters);
    }

    /**
     */
    async apiSupplierLocationMappingFormValidatePostRaw(requestParameters: ApiSupplierLocationMappingFormValidatePostRequest): Promise<runtime.ApiResponse<SupplierLocationMappingValidationData>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SupplierLocationMappingForm/Validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupplierLocationMappingFormDataToJSON(requestParameters.supplierLocationMappingFormData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupplierLocationMappingValidationDataFromJSON(jsonValue));
    }

    /**
     */
    async apiSupplierLocationMappingFormValidatePost(requestParameters: ApiSupplierLocationMappingFormValidatePostRequest): Promise<SupplierLocationMappingValidationData> {
        const response = await this.apiSupplierLocationMappingFormValidatePostRaw(requestParameters);
        return await response.value();
    }

}
